import styled from "styled-components/macro"

export const StatusWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  
  color: ${({ theme }) => theme.colors.blackMedium};
  font-size: ${({ theme }) => theme.typography.fontSizeCaption};
  line-height: 14px;
`

export const StatusTitle = styled.span`
  margin-bottom: 8px;
  text-align: center;
`
